import {Link} from "react-router-dom";
import {Card, styled} from "@reside/ui";

export const StyledLink = styled(Link)`
  line-height: 14px;
  font-size: 14px;

  &:hover {
    opacity: 0.7;
  }
`;

export const StyledButtonLinkWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;

  a {
    display: block;
  }
`;

export const StyledCard = styled(Card)`
  max-width: 400px;
  margin: 0 auto;
  padding: ${({theme}) =>
    `${theme.space[5]}px ${theme.space[7]}px ${theme.space[5]}px ${theme.space[7]}px`};

  input {
    font-size: 18px;
  }
`;
